//
//
//
//
//
//
//
//

import Chart from "chart.js";
import annotation from "chartjs-plugin-annotation";
import {mapGetters} from "vuex";

export default {
  name: "Graph",

  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      },
    },
    baseLine: {
      type: Array,
      default: function () {
        return [];
      },
    },
    dates: {
      type: Array,
      default: function () {
        return [];
      },
    },
    height: {
      type: Number,
      default: 100,
    },
    aspectRatio: {
      type: Boolean,
      default: false,
    },
    summary: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    pointRadius: {
      type: Number,
      default: 0,
    },
    disableBaseline: {
      type: Boolean,
      value: false,
    },
    axisLabel:{
      type: String,
      value: 'graph.axis.evaluations',
    },
  },

  mounted() {
    this.createChart();
  },

  data: () => ({
    currentGraph: {},
    disableChart: true,
  }),

  computed: {
    ...mapGetters(["enrichers"]),
    gradientStroke() {
      let ctx = this.$refs.cardChart.getContext("2d");
      let gradientStroke = ctx.createLinearGradient(500, 0, 0, 400);
      let primaryColor = "#53A0FD";
      let secondaryColor = "#D60000";

      gradientStroke.addColorStop(0.2, primaryColor);
      gradientStroke.addColorStop(1, secondaryColor);
      return gradientStroke;
    },

    shadowStroke() {
      let ctx = this.$refs.cardChart.getContext("2d");
      let gradientStroke = ctx.createLinearGradient(0, 500, 0, 0);
      let primaryColor = "#53A0FD";
      let secondaryColor = "white";

      gradientStroke.addColorStop(1, primaryColor);
      gradientStroke.addColorStop(0.7, secondaryColor);
      return gradientStroke;
    },

    datasets() {
      return [
        {
          label: this.$t("model.missions.form.goal.label"),
          data: this.baseLine,
          borderColor: "grey",
          borderWidth: 1,
          borderDash: [5, 5],
          fill: false,
          pointRadius: 0,
        },
        {
          label: this.$t(this.axisLabel),
          data: this.data,
          borderColor: "#0066FF",
          backgroundColor: "rgba(0, 102, 255, 0.2)",
          borderWidth: 1,
          fill: true,
          pointRadius: this.pointRadius,
          lineTension: this.shadow ? 0 : 0.35,
        },
      ];
    },

    annotations() {
      if (this.disableChart) {
        return {
          annotations: [
            {
              type: "line",
              mode: "horizontal",
              scaleID: "y-axis-0",
              value: 50,
              borderColor: "black",
              borderWidth: 0.1,
              label: {
                content: "No evaluations yet",
                enabled: true,
              },
            },
          ],
        };
      } else {
        return {};
      }
    },

    options() {
      return {
        annotation: this.annotations,
        responsive: true,
        maintainAspectRatio: this.aspectRatio,
        hover: {
          mode: "index",
        },
        legend: {
          display: this.summary,
          position: "bottom",
        },
        scales: {
          xAxes: [
            {
              display: this.summary,
              type: "category",
              labels: this.dates,
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
            },
          ],
          yAxes: [
            {
              display: this.summary,
              scaleLabel: {
                display: false,
                // labelString: 'Accuracy',
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              },
              ticks: {
                beginAtZero: true,
                stepSize: 25,
                max: 100,
                callback: function (value) {
                  return value + "%";
                },
              },
            },
          ],
        },
      };
    },
  },

  methods: {
    createChart() {
      if (Object.keys(this.currentGraph).length !== 0) {
        this.currentGraph.destroy();
      }

      if (this.baseLine.length > 0 || this.disableBaseline) {
        this.disableChart = false;
      }

      this.currentGraph = new Chart(this.$refs.cardChart, {
        plugins: [annotation],
        maintainAspectRatio: true,
        type: "line",
        data: {
          datasets: this.datasets,
        },
        options: this.options,
      });
    },
  },
};
